import React, { Fragment } from 'react';
import OnlineProcessUi from '../../../../components/user-interfaces/online-process/online-process.ui';

/**
 * Composant de la page mentions légales
 * Les données de la page sont récupérées via l'API
 * @constructor
 */
export default function OnLineProceduresPage() {
    return (
        <Fragment>
            <OnlineProcessUi />
        </Fragment>
    );
}
